var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('div',{staticClass:"col-md-12 p-0",staticStyle:{"height":"calc(100vh - 65px)"}},[_c(_vm.selectedComponent,{tag:"component",attrs:{"personalityId":_vm.selectedPersonalityId},on:{"changeSelectedComponent":_vm.changeSelectedComponent}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }